import type { Faction, FactionId, Subject } from './types';

export const FACTIONS: Record<FactionId, Faction> = {
  celestial: { id: 'celestial', displayName: '星算門', emoji: '⚡', colorPrimary: 0x6a1b9a },
  runic:     { id: 'runic',     displayName: '符文門', emoji: '🔮', colorPrimary: 0xad1457 },
  techno:    { id: 'techno',    displayName: '機械門', emoji: '🤖', colorPrimary: 0x1976d2 },
  elemental: { id: 'elemental', displayName: '自然門', emoji: '🌀', colorPrimary: 0x00897b },
  dominion:  { id: 'dominion',  displayName: '疆域門', emoji: '🏰', colorPrimary: 0x6d4c41 },
};

/** Full colour tokens per faction: primary + accent, as Phaser number and CSS hex string. */
export const FACTION_COLORS: Record<FactionId, {
  primary: number; primaryHex: string;
  accent: number;  accentHex: string;
}> = {
  celestial: { primary: 0x6a1b9a, primaryHex: '#6a1b9a', accent: 0xffd54f, accentHex: '#ffd54f' },
  runic:     { primary: 0xad1457, primaryHex: '#ad1457', accent: 0xffffff, accentHex: '#ffffff' },
  techno:    { primary: 0x1976d2, primaryHex: '#1976d2', accent: 0xcfd8dc, accentHex: '#cfd8dc' },
  elemental: { primary: 0x00897b, primaryHex: '#00897b', accent: 0x80cbc4, accentHex: '#80cbc4' },
  dominion:  { primary: 0x6d4c41, primaryHex: '#6d4c41', accent: 0xffd54f, accentHex: '#ffd54f' },
};

const SUBJECT_TO_FACTION: Record<Subject, FactionId> = {
  math:    'celestial',
  chinese: 'runic',
  english: 'techno',
  nature:  'elemental',
  social:  'dominion',
};

export function factionForSubject(subject: Subject): FactionId {
  return SUBJECT_TO_FACTION[subject];
}
